module.exports = __webpack_public_path__ + "media/images/gathered-935b10587c17c528c80b401380a4a919.png";